// extracted by mini-css-extract-plugin
module.exports = {"cardsIconJ":"CardsIconJ_cardsIconJ__XyoZU"};